export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-smashing-mag-519516fcb965837ae6df44e24bac853f.svg";